// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTakeaways_root__vlycK","title":"ArticleTakeaways_title__kKv6x","list":"ArticleTakeaways_list__JQ1Ho","item":"ArticleTakeaways_item__TE9I6"};